import { ContainerTreeObject } from '@/frontend/types/navigationTypes';
import { ParameterType } from '@/types/parameterTypes';
import { Lightning } from '@/frontend/SVGs/Lightning';
import { useParameterStore } from '@/frontend/store/ParameterStore';
import { I18n } from '@/i18n/I18n';
import { useShallow } from 'zustand/react/shallow';
import { ParameterItemRun } from '../parameters/ParameterItemRun';
import { ParameterLink } from '../parameters/ParameterLink';
import { DeleteButton } from '../buttons/DeleteButton';
import { useTreeStore } from '@/frontend/store/TreeStore';

export function FunctionCall(props: { initItem: ContainerTreeObject }) {
  const { initItem } = props;
  const container = initItem.container;
  const deleteContainer = useTreeStore(state => state.deleteContainer);

  return (
    <div id={initItem.id} className="card bg-primary-subtle mt-2">
      <div className="card-body">
        <div className='d-flex justify-content-between'>
          <div className='text-primary'><Lightning/> {I18n.get('interfaceFunctionCall')}</div>
          <DeleteButton title={container.title} onDelete={() => deleteContainer(container)} model={I18n.get('interfaceFunctionCall')} />
        </div>
        <code>{container.title}</code>
        <ParameterList subjectId={container.id} parameterType={ParameterType.INPUT} />
        <ParameterList subjectId={container.id} parameterType={ParameterType.OUTPUT} />
      </div>
    </div>
  );
}

function ParameterList(props: { subjectId: string, parameterType: ParameterType }) {
  const { subjectId, parameterType } = props;
  const parameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(subjectId, parameterType)));

  if (parameters.length === 0) return null;

  return (
    <div className='mt-2'>
      <div className='text-muted fw-semibold'>{I18n.get('typeParameters', { type: I18n.get(parameterType) })}
      </div>
      <div className='card p-3'>
        { parameters.map((parameter, index) => (
          <div id={parameter.id} key={parameter.id}>
            <div className='d-flex gap-2'>
              <div className='flex-fill'><ParameterItemRun parameter={parameter} alwaysEnabled /></div>
              <ParameterLink parameter={parameter} />
            </div>
            {index < parameters.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
}
